import type {
    authStatusResponse,
    loginFormData,
    loginResponse,
} from "@/features/login/types.api";
import axiosInstance, { setAccessToken } from "@/lib/axios";

export const login = async (
    credentials: loginFormData,
): Promise<loginResponse> => {
    const { data } = await axiosInstance.post<loginResponse>(
        "/auth/login/",
        credentials,
    );
    if (data.access) {
        setAccessToken(data.access);
    }
    return data;
};

export const logout = async (): Promise<void> => {
    await axiosInstance.post("/auth/logout/");
    setAccessToken(null);
};

export const authStatus = async (): Promise<authStatusResponse> => {
    const { data } = await axiosInstance.get<authStatusResponse>("/auth/status/");
    return data;
};
